import React from "react";

const CheckIcon = ({ color = "white", ...rest }) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" {...rest}>
    <path d="M2 7l3.5 3.5L12 3" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default CheckIcon;
